import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import extLinkIcon from "../img/External_Link.svg";

function ProjectPreview(props) {
  
  const history = useHistory();

  function navigate(link){
    history.push(`/project/${link}`);
  }

  function navigateOutside(link){
    window.open(link);
  }

  return (
            <div className="ProjectPreview" onClick={()=> 
                {
                    props.project.shortTitle ? 
                    navigate(props.project.shortTitle) :
                    props.project.extLink ?
                    navigateOutside(props.project.extLink) :
                    navigate(`/`);
                }
            }>
                <LazyLoadImage 
                    src={props.project.previewImg.src} 
                    alt={props.project.previewImg.alt}
                    />
                <div className="ProjectText">
                    {props.project.shortTitle && (
                        <h4>
                            {props.project.title}
                        </h4>
                    )}
                    {props.project.extLink && !props.project.shortTitle && (
                        <h4>
                            {props.project.title}
                            <img src={extLinkIcon} className="external-icon" alt="External link icon" />
                        </h4>
                    )}
                        <p>{props.project.description}</p>
                </div>
            </div>
  );
}

export default ProjectPreview;
